export default __webpack_public_path__ + "static/media/Image1.e8f55824.png";